import { NAV_V2_LOGGED_OUT_LINKS_BP } from '@dtx-company/true-common/src/constants/layout'

export function getTopNavDesktopBreakpoint(showPlatformNav: boolean): number {
  return showPlatformNav ? 832 : NAV_V2_LOGGED_OUT_LINKS_BP
}
